.xFootnote {
    display: inline;
    vertical-align: middle;
    margin: 0 2px;
    cursor: help;
}

.icon {
    width: 15px;
    height: 15px;
    color: var(--article-link);
    transform: scaleX(-1);
}
